import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-0"}],["path",{"d":"M9 10l.01 0","key":"svg-1"}],["path",{"d":"M15 10l.01 0","key":"svg-2"}],["path",{"d":"M9.5 15.25a3.5 3.5 0 0 1 5 0","key":"svg-3"}]]

const IconMoodSad = createReactComponent('outline', 'mood-sad', 'MoodSad', __iconNode);

export default IconMoodSad;